<template>
    <div class="bg-base-300 min-h-screen flex flex-col">
        <NavBar />
        <div class="flex-1 flex justify-center">
            <div class="w-full max-w-2xl pb-20">
                <RouterView
                    :key="refreshKey"
                    :can-make-entry="canMakeEntry"
                    :entry-processing-id="entryProcessingId"
                />
            </div>
        </div>
        <div class="fixed bottom-0 left-0 right-0">
            <TabBar
                :polling="polling"
                @add="sheetOpen = true"
            />
        </div>

        <BottomSheet v-model="sheetOpen">
            <NewEntry
                :can-make-entry="canMakeEntry"
                :entry-processing-id="entryProcessingId"
                @entry-processed="entryProcessed"
            />
        </BottomSheet>
    </div>
</template>

<script>
import NavBar from 'components/nav-bar.vue';
import TabBar from 'components/tab-bar.vue';
import BottomSheet from 'components/bottom-sheet.vue';
import NewEntry from 'components/home/new-entry.vue';
import apiClient from 'api/apiClient.js';

export default {
    name: 'HomeLayout',
    components: { NavBar, TabBar, BottomSheet, NewEntry },
    data: () => ({
        sheetOpen: false,
        canMakeEntry: false,
        entryProcessingId: null,
        refreshKey: 0,
        polling: false,
    }),
    created() {
        this.getNewEntryState();
    },
    beforeUnmount() {
        this.polling = false;
    },
    methods: {
        entryProcessed() {
            this.sheetOpen = false;
            this.getNewEntryState();
        },
        async getNewEntryState() {
            const response = await apiClient.get('/api/home/new-entry');
            this.canMakeEntry = response.new_entry;
            this.entryProcessingId = response.entry_processing_id;
            if (this.entryProcessingId) this.startPolling();
        },
        async startPolling() {
            if (this.polling) return;
            this.polling = true;
            try {
                while (this.polling && this.entryProcessingId) {
                    await new Promise((resolve) => setTimeout(resolve, 5000));
                    if (!this.polling) break;
                    const response = await apiClient.get(`/api/home/entry/${this.entryProcessingId}`);
                    if (response.processed) {
                        this.entryProcessingId = null;
                        this.canMakeEntry = true;
                        this.refreshKey++;
                        break;
                    }
                }
            } catch (error) {
                console.error('Polling failed:', error);
            } finally {
                this.polling = false;
            }
        },
    },
};
</script>
